import { booleanAttribute, Directive, input } from '@angular/core';

/**
 * Marks an `ara-generic-table` / `ara-slim-table` as read-only: the table hides the EDIT/ADD
 * affordances — per-row actions (three-dot menu), the add row, the gray action bar and the
 * header-action buttons — while the browsing controls stay: search bar, fullscreen, column
 * filter and paginator.
 *
 * The host table injects this directive (optional, self) and routes its chrome visibility
 * through it, so a table without the directive behaves exactly as before. In `ara-generic-table`
 * the add row lives in the caller's table template, so the caller gates it on `shell.isReadMode()`.
 *
 * ```html
 * <ara-generic-table araReadMode …></ara-generic-table>          <!-- always read-only -->
 * <ara-slim-table [araReadMode]="!editing()" …></ara-slim-table> <!-- toggled -->
 * ```
 */
@Directive({
	selector: 'ara-generic-table[araReadMode], ara-slim-table[araReadMode]',
	standalone: true,
})
export class AraReadModeDirective {
	/** Read-only when truthy; bare attribute (`araReadMode`) counts as `true`. */
	readonly araReadMode = input(true, { transform: booleanAttribute });
}
